import DOMPurify from 'isomorphic-dompurify';

const options = {
	ALLOWED_TAGS: [
		// text formatting
		'a',
		'b',
		'br',
		'i',
		'em',
		'strong',
		's',
		'strike',
		'del',
		'u',
		// block elements
		'p',
		'div',
		'span',
		// lists
		'ul',
		'ol',
		'li',
		'pre',
		// code blocks
		'code',
		'blockquote',
		// images
		'img',
	],
	ALLOWED_ATTR: [
		'href',
		'target',
		'rel', // link attributes
		'class', // for styling
		'src',
		'alt', // image attributes
	],
};

export const useSanitizeRichText = (text: string) => DOMPurify.sanitize(text, options);

export const sanitize = (text: string) => DOMPurify.sanitize(text, options);

// Table tags are scoped to this variant rather than added to the shared allowlist above, which the
// bonus feed, incentives, and growth notes all rely on staying narrow. Presentational attributes the
// provider ships (cellpadding, inline styles) are still dropped; styling comes from the caller.
export const sanitizeTabularRichText = (text: string) =>
	DOMPurify.sanitize(text, {
		...options,
		ALLOWED_TAGS: [...options.ALLOWED_TAGS, 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
		ALLOWED_ATTR: [...options.ALLOWED_ATTR, 'colspan', 'rowspan', 'scope'],
	});
